import { AgStepbar } from '@rededor/ag-shared-components-react'
import { useStepbarNavigation } from '@/hooks/useStepbarNavigation'
import { DoctorSpecialtyStep } from './steps/DoctorSpecialtyStep'
import { LocationStep } from './steps/LocationStep'
import { PatientStep } from './steps/PatientStep'
import { PaymentStep } from './steps/PaymentStep'
import { ScheduleStep } from './steps/ScheduleStep'
import { useScheduleStore } from '@/store/useScheduleStore'

import { Show } from '../Show'

export const StepBar = () => {
  const flowType = useScheduleStore((s) => s.flowType)
  const isFlowTypeDoctor = flowType === 'doctor'

  const {
    handleBackwardNavigation,
    handleForwardNavigation,
    isDisabledBackwardButton,
    isDisabledForwardButton
  } = useStepbarNavigation()

  const handleNavigation = (evt: CustomEvent) => {
    if (evt.detail === 'backward') {
      handleBackwardNavigation()

      return
    }

    handleForwardNavigation()
  }

  return (
    <>
      <AgStepbar
        disabledBackwardNavigation={isDisabledBackwardButton}
        disabledForwardNavigation={isDisabledForwardButton}
        onNavigate={handleNavigation}
      >
        <DoctorSpecialtyStep />
        <Show when={!isFlowTypeDoctor}>
          <LocationStep />
        </Show>
        <PatientStep />
        <PaymentStep />
        <ScheduleStep />
      </AgStepbar>
    </>
  )
}
